import {css, Theme} from "@emotion/react";

import {calculateRemSize as crs, onDesktop, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import expertImage from "../assets/wojciech_sosnowski.png";

export function OfferRankingExpert() {
    return (
        <div css={offerRankingExpert}>
            <div css={wrap}>
                <div css={expertMessage}>
                    <Text variant="headline_2" as="h3">
                        Okiem eksperta
                    </Text>
                    <Text css={expertText}>
                        Obraz to kluczowy sposób prezentacji inwestycji mieszkaniowych. Wizualizacje i zdjęcia zrealizowanych budynków przekazują wiele
                        informacji i kształtują nasze emocje. Deweloperzy wykorzystują postrzeganie wzorców, barw i kształtów, aby pokazać elewacje, wnętrza i
                        otoczenie w najbardziej atrakcyjny i przekonujący sposób. Choć pisemne deklaracje są ważne, to właśnie obrazy najmocniej wpływają na
                        nasze odczucia. Elementy takie jak okna, balkony czy kształt budynku pozostają niezmienne, ale drzewa i zieleń będą wzrastać i rozwijać
                        się. Projekty budynków, które odwołują się do naszych emocji, niosą ze sobą przekonanie o istotności życia w harmonii z naturą. To
                        zadanie dla deweloperów i projektantów: stworzyć budynek, w którym chcielibyśmy zamieszkać.
                    </Text>
                </div>
                <div css={expert}>
                    <Image alt="Wojciech Sosnkowski" width="192px" height="192px" src={expertImage} css={expertImageStyle} />
                    <div css={expertDescription}>
                        <Text variant="headline_6" as="p" css={expertDescriptionAlign}>
                            Wojciech Sosnowski
                        </Text>
                        <Text variant="info_txt_1" css={expertDescriptionAlign}>
                            Specjalista w zarządzaniu procesem projektowym i produktem w branży deweloperskiej. Autor uniwersalnej metody oceny standardu
                            inwestycji deweloperskich.
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Styles
const offerRankingExpert = (theme: Theme) => css`
    background: ${theme.colors.gray[200]};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const wrap = css`
    max-width: 936px;
    ${p(4, 3)};
    display: flex;
    flex-direction: column;
    gap: ${crs(4)};

    ${onDesktop(css`
        flex-direction: row;
    `)}
`;

const expertMessage = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    ${onDesktop(css`
        order: 1;
    `)}
`;

const expertText = css`
    font-style: italic;
`;

const expert = css`
    display: flex;
    gap: ${crs(2)};
    align-items: center;
    justify-content: center;

    ${onDesktop(css`
        flex-direction: column;
        gap: ${crs(3)};
        order: 0;
    `)}
`;

const expertImageStyle = css`
    flex: 0 0 auto;
    width: ${crs(12)};
    height: ${crs(12)};

    & > img {
        width: 100%;
        height: 100%;
    }

    ${onDesktop(css`
        width: ${crs(24)};
        height: ${crs(24)};
    `)}
`;

const expertDescription = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(0.5)};
    max-width: 244px;
`;

const expertDescriptionAlign = css`
    ${onDesktop(css`
        text-align: center;
    `)}
`;
import {css, Theme} from "@emotion/react";

import {calculateRemSize as crs, onDesktop, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import expertImage from "../assets/wojciech_sosnowski.png";

export function OfferRankingExpert() {
    return (
        <div css={offerRankingExpert}>
            <div css={wrap}>
                <div css={expertMessage}>
                    <Text variant="headline_2" as="h3">
                        Okiem eksperta
                    </Text>
                    <Text css={expertText}>
                        Obraz to kluczowy sposób prezentacji inwestycji mieszkaniowych. Wizualizacje i zdjęcia zrealizowanych budynków przekazują wiele
                        informacji i kształtują nasze emocje. Deweloperzy wykorzystują postrzeganie wzorców, barw i kształtów, aby pokazać elewacje, wnętrza i
                        otoczenie w najbardziej atrakcyjny i przekonujący sposób. Choć pisemne deklaracje są ważne, to właśnie obrazy najmocniej wpływają na
                        nasze odczucia. Elementy takie jak okna, balkony czy kształt budynku pozostają niezmienne, ale drzewa i zieleń będą wzrastać i rozwijać
                        się. Projekty budynków, które odwołują się do naszych emocji, niosą ze sobą przekonanie o istotności życia w harmonii z naturą. To
                        zadanie dla deweloperów i projektantów: stworzyć budynek, w którym chcielibyśmy zamieszkać.
                    </Text>
                </div>
                <div css={expert}>
                    <Image alt="Wojciech Sosnkowski" width="192px" height="192px" src={expertImage} css={expertImageStyle} />
                    <div css={expertDescription}>
                        <Text variant="headline_6" as="p" css={expertDescriptionAlign}>
                            Wojciech Sosnowski
                        </Text>
                        <Text variant="info_txt_1" css={expertDescriptionAlign}>
                            Specjalista w zarządzaniu procesem projektowym i produktem w branży deweloperskiej. Autor uniwersalnej metody oceny standardu
                            inwestycji deweloperskich.
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Styles
const offerRankingExpert = (theme: Theme) => css`
    background: ${theme.colors.gray[200]};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const wrap = css`
    max-width: 936px;
    ${p(4, 3)};
    display: flex;
    flex-direction: column;
    gap: ${crs(4)};

    ${onDesktop(css`
        flex-direction: row;
    `)}
`;

const expertMessage = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    ${onDesktop(css`
        order: 1;
    `)}
`;

const expertText = css`
    font-style: italic;
`;

const expert = css`
    display: flex;
    gap: ${crs(2)};
    align-items: center;
    justify-content: center;

    ${onDesktop(css`
        flex-direction: column;
        gap: ${crs(3)};
        order: 0;
    `)}
`;

const expertImageStyle = css`
    flex: 0 0 auto;
    width: ${crs(12)};
    height: ${crs(12)};

    & > img {
        width: 100%;
        height: 100%;
    }

    ${onDesktop(css`
        width: ${crs(24)};
        height: ${crs(24)};
    `)}
`;

const expertDescription = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(0.5)};
    max-width: 244px;
`;

const expertDescriptionAlign = css`
    ${onDesktop(css`
        text-align: center;
    `)}
`;
